// extracted by mini-css-extract-plugin
export var body = "_lc-8";
export var button = "_lc-0";
export var closeButton = "_lc-5";
export var content = "_lc-3";
export var empty = "_lc-f";
export var grid = "_lc-c";
export var header = "_lc-4";
export var icon = "_lc-1";
export var option = "_lc-d";
export var optionSelected = "_lc-e";
export var overlay = "_lc-2";
export var searchIcon = "_lc-a";
export var searchInput = "_lc-b";
export var searchWrapper = "_lc-9";
export var title = "_lc-6";
export var visuallyHidden = "_lc-7";